import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

function FilterTabs({ tabs, isExpanded, className }) {
  return (
    <div className={`${styles.filters} ${className}`}>
      {tabs &&
        tabs.map((tab, index) =>
          tab.show ? (
            <div className={styles.filter} key={index}>
              <button
                type='button'
                className={`${styles.filterBtn} ${isExpanded && styles.filterButtonExpanded} ${
                  tab.selected && styles.filterSelected
                } ${tab.isSubTab ? (tab.selected ? styles.hybridFilterSelected : styles.hybridFilter) : ''} `}
                onClick={tab.onClick}>
                {tab.display}
              </button>
              {tab.info && <span className={styles.count}>{tab.info}</span>}
            </div>
          ) : null
        )}
    </div>
  )
}

FilterTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  isExpanded: PropTypes.bool
}

FilterTabs.defaultProps = {
  isExpanded: false
}

export default FilterTabs
